import React, { useRef, useState, useEffect } from "react";
import io from "socket.io-client";
import DepartmentDropdown from "./DepartmentDropdown";
import axios from "axios";
import "./Ticket2.css";
import { useNavigate } from "react-router-dom";
axios.defaults.withCredentials = true;

const EMAIL_REGEX = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;

const extractValidEmails = (values) => {
  const set = new Set();
  (values || []).forEach((raw) => {
    if (!raw) return;
    const s = String(raw);
    s.split(/[,\s;]+/).forEach((piece) => {
      const hits = String(piece).match(EMAIL_REGEX);
      if (hits) hits.forEach((e) => set.add(e.toLowerCase()));
    });
    const hitsWhole = s.match(EMAIL_REGEX);
    if (hitsWhole) hitsWhole.forEach((e) => set.add(e.toLowerCase()));
  });
  return [...set];
};

const StatusBadge = ({ status }) => {
  const getStatusClass = () => {
    switch (status?.toLowerCase()) {
      case "open":
        return "status status-open";
      case "foundcause":
        return "status status-foundcause";
      case "closed":
        return "status status-closed";
      case "nextfollowup":
        return "status status-nextfollowup";
      default:
        return "status";
    }
  };
  return <span className={getStatusClass()}>{status}</span>;
};

const PriorityIndicator = ({ level }) => {
  const getPriorityClass = () => {
    switch (level?.toLowerCase()) {
      case "high":
        return "priority priority-high";
      case "critical":
        return "priority priority-critical";
      case "medium":
        return "priority priority-medium";
      case "low":
        return "priority priority-low";
      default:
        return "priority";
    }
  };
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <span className={getPriorityClass()}></span>
      {level}
    </div>
  );
};

const TicketDetailAdmin2 = ({ ticket, formatDate }) => {
  const [alertMessage, setAlertMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [ticketStatus, setTicketStatus] = useState(ticket.Status || "open");
  const [recipients, setRecipients] = useState("");
  const [responses, setResponses] = useState([]);
  const [socket, setSocket] = useState(null);
  const [, setTickets] = useState([]);
  const [subject, setSubject] = useState(ticket.Details || "");
  const [isUpdatingSubject, setIsUpdatingSubject] = useState(false);
  const [isEditingSubject, setIsEditingSubject] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [selectedRecipients, setSelectedRecipients] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [newSeverity, setNewSeverity] = useState(
    ticket.SeverityLevels || "low",
  );
  const [isUpdatingSeverity, setIsUpdatingSeverity] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [replyFiles, setReplyFiles] = useState([]);
  const fileInputRef = useRef(null);

  const [repairCaseTypes, setRepairCaseTypes] = useState([]);
  const [selectedRepairCaseTypeId, setSelectedRepairCaseTypeId] = useState(
    ticket.repair_case_type_id ? String(ticket.repair_case_type_id) : "",
  );

  const [pendingRepairCaseTypeId, setPendingRepairCaseTypeId] = useState(
    ticket.repair_case_type_id ? String(ticket.repair_case_type_id) : "",
  );

  const [currentAssetSerial, setCurrentAssetSerial] = useState(
    ticket.customer_asset_serial || "",
  );
  const [isUpdatingRepairCase, setIsUpdatingRepairCase] = useState(false);

  const [me, setMe] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get("/authadmin/me", {
          withCredentials: true,
        });
        setMe(res.data.user || null);
      } catch {
        setMe(null);
      }
    })();
  }, []);
  const employeeId = me?.id || null;
  const navigate = useNavigate();
  const chatContainerRef = useRef(null);

  const confirmResolveRef = useRef(null);

  const [confirmPopup, setConfirmPopup] = useState({
    open: false,
    title: "",
    message: "",
    confirmText: "ยืนยัน",
    cancelText: "ยกเลิก",
    variant: "primary",
  });

  const serialResolveRef = useRef(null);

  const [serialPopup, setSerialPopup] = useState({
    open: false,
    title: "",
    message: "",
    value: "",
    error: "",
  });

  const openConfirmPopup = ({
    title,
    message,
    confirmText = "ยืนยัน",
    cancelText = "ยกเลิก",
    variant = "primary",
  }) => {
    return new Promise((resolve) => {
      confirmResolveRef.current = resolve;

      setConfirmPopup({
        open: true,
        title,
        message,
        confirmText,
        cancelText,
        variant,
      });
    });
  };

  const openSerialPopup = ({ title, message }) => {
    return new Promise((resolve) => {
      serialResolveRef.current = resolve;

      setSerialPopup({
        open: true,
        title,
        message,
        value: "",
        error: "",
      });
    });
  };

  const closeSerialPopup = (value) => {
    if (serialResolveRef.current) {
      serialResolveRef.current(value);
      serialResolveRef.current = null;
    }

    setSerialPopup((prev) => ({
      ...prev,
      open: false,
      value: "",
      error: "",
    }));
  };

  const confirmSerialPopup = () => {
    const value = serialPopup.value.trim();

    if (!value) {
      setSerialPopup((prev) => ({
        ...prev,
        error: "กรุณากรอก Serial ใหม่",
      }));
      return;
    }

    closeSerialPopup(value);
  };

  const closeConfirmPopup = (result) => {
    if (confirmResolveRef.current) {
      confirmResolveRef.current(result);
      confirmResolveRef.current = null;
    }

    setConfirmPopup((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const [repairResultNote, setRepairResultNote] = useState(
    ticket.repair_result_note || "",
  );

  const [isWritingCustomRepairResult, setIsWritingCustomRepairResult] =
    useState(false);

  useEffect(() => {
    setRepairResultNote(ticket?.repair_result_note || "");
  }, [ticket?.repair_result_note]);
  const [isUpdatingRepairResultNote, setIsUpdatingRepairResultNote] =
    useState(false);
  const [repairResultNoteSuccess, setRepairResultNoteSuccess] = useState("");

  const createEmailTemplate = (recpient, messageData, senderName) => {
    const latestMsg = messageData.message;

    return `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <style>
            body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
            .container { max-width: 600px; margin: 0 auto; padding: 20px; }
            .header { background-color: #007bff; color: white; padding: 20px; border-radius: 5px 5px 0 0; }
            .content { background-color: #f8f9fa; padding: 20px; border: 1px solid #dee2e6; }
            .footer { background-color: #6c757d; color: white; padding: 15px; text-align: center; border-radius: 0 0 5px 5px; }
            .message-box { background-color: white; padding: 15px; border-left: 4px solid #007bff; margin: 15px 0; }
            .btn { display: inline-block; padding: 10px 20px; background-color: #007bff; color: white; text-decoration: none; border-radius: 5px; }
            </style>
          </head>
          <body>
            <div className="container">
            <div className="header">
            <h2>🎫 Ticket #${ticket.id} (${ticket.FullName}/${
              ticket.IssueSummary
            })</h2>
          </div>
            
             <div className="content">
              <p><strong>ข้อความล่าสุด:</strong> ${latestMsg}</p>
              <h3>📋 รายละเอียด Ticket:</h3>
              <ul>
                <li><strong>หัวข้อ:</strong> ${ticket.IssueSummary}</li>
                <li><strong>รายละเอียด:</strong> ${ticket.Details}</li>
                <li><strong>สถานะปัจจุบัน:</strong> ${messageData.Status}</li>
                <li><strong>วันที่สร้าง:</strong> ${formatDate(
                  ticket.Date,
                )}</li>
              </ul>
              </p> 
            </div>
          </div>
        </body>
        </html>
      `;
  };

  const sendEmailNotification = async (emails, messageData) => {
    const senderName = me?.email || "Admin";

    const uniqEmails = [
      ...new Set((emails || []).map((e) => (e || "").trim()).filter(Boolean)),
    ];
    if (uniqEmails.length === 0) return;

    const emailData = {
      to: uniqEmails,
      subject: `Ticket #${messageData.ticket_id} (${ticket.FullName}/${ticket.IssueSummary})`,
      html: createEmailTemplate(null, messageData, senderName),
    };
    try {
      await axios.post(
        "/ticketadmin/send-notification-email",
        emailData,
        {
          withCredentials: true,
        },
      );
    } catch (error) {
      console.error("❌ Failed to send email notifications:", error);
    }
  };

  const today = new Date().toISOString().split("T")[0];

  const [nextFollowupDate, setNextFollowupDate] = useState(
    ticket.next_followup_date ? ticket.next_followup_date.split("T")[0] : "",
  );

  useEffect(() => {
    const fetchRepairCaseTypes = async () => {
      try {
        const res = await axios.get(
          "/ticketadmin/repair-case-types",
          {
            withCredentials: true,
          },
        );

        setRepairCaseTypes(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Failed to fetch repair case types:", err);
      }
    };

    fetchRepairCaseTypes();
  }, []);

  useEffect(() => {
    const currentRepairCaseId = ticket.repair_case_type_id
      ? String(ticket.repair_case_type_id)
      : "";

    setSelectedRepairCaseTypeId(currentRepairCaseId);
    setPendingRepairCaseTypeId(currentRepairCaseId);

    setCurrentAssetSerial(ticket.customer_asset_serial || "");
  }, [ticket]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (recipients.trim() === "") {
      setAlertMessage("⚠️ Please fill out all required fields.");
      return;
    }

    if (selectedRecipients.length === 0) {
      setAlertMessage("⚠️ Please select at least one recipient in 'Reply To'.");
      return;
    }

    if (ticketStatus === "nextfollowup") {
      if (!nextFollowupDate) {
        setAlertMessage("⚠️ Please choose a follow‑up date.");
        return;
      }
      if (nextFollowupDate < today) {
        setAlertMessage("⚠️ Follow-up date cannot be in the past.");
        return;
      }
    }

    setIsSubmitting(true);

    try {
      const isCustomerSelected = selectedRecipients.includes(
        String(ticket.customer_id),
      );

      const uploadedFileNames = [];
      if (replyFiles?.length) {
        for (const f of replyFiles) {
          const name = await uploadFileToServer(f);
          if (name) uploadedFileNames.push(name);
        }
      }

      const messageData = {
        ticket_id: ticket.id,
        customer_id: isCustomerSelected ? ticket.customer_id : null,
        Email_admin: employeeId,
        message: recipients || "No Message",
        AttachFiles: uploadedFileNames,
        Reply: selectedRecipients.length ? selectedRecipients.join(",") : null,
        Status: ticketStatus,
        NextFollowupDate:
          ticketStatus === "nextfollowup" ? nextFollowupDate : null,
      };

      if (socket?.connected) {
        socket.emit("sendMessage", messageData);
      } else {
        console.warn("Socket not connected; queueing only email.");
      }

      const rawTargets = [];

      if (isCustomerSelected && ticket.Email) {
        rawTargets.push(ticket.Email);
      }
      selectedRecipients.forEach((val) => {
        if (!val) return;
        rawTargets.push(val);

        const dept = departmentData.find((d) => String(d.id) === String(val));
        if (dept) {
          if (dept.email) rawTargets.push(dept.email);
          (dept.members || []).forEach(
            (m) => m?.email && rawTargets.push(m.email),
          );
        }
      });

      const emailTargets = extractValidEmails(rawTargets);
      if (emailTargets.length) {
        await sendEmailNotification(emailTargets, messageData);
      } else {
        console.warn("No valid email targets; skipped email sending.");
      }

      setReplyFiles([]);
      if (fileInputRef.current) fileInputRef.current.value = "";
      setRecipients("");
      setSelectedRecipients([]);

      setAlertMessage("✅ Ticket saved successfully and notifications sent!");
      setTimeout(() => setAlertMessage(""), 3000);
    } catch (error) {
      console.error("❌ Error saving ticket:", error.response?.data || error);
      setAlertMessage("❌ Failed to save ticket. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeleteFile = async (fileToDelete) => {
    const confirmDelete = await openConfirmPopup({
      title: "ยืนยันการลบไฟล์",
      message: `คุณต้องการลบไฟล์ "${fileToDelete}" ใช่หรือไม่?`,
      confirmText: "ยืนยันลบ",
      cancelText: "ยกเลิก",
      variant: "danger",
    });

    if (!confirmDelete) return;

    setIsSubmitting(true);
    try {
      const { data } = await axios.post(
        "/ticketadmin/removeAttachFile",
        {
          TicketNumber: ticket.id,
          fileToDelete,
        },
        {
          withCredentials: true,
        },
      );

      if (data.success) {
        setAttachedFiles(data.attachedFiles);
        setAlertMessage("✅ ไฟล์ถูกลบเรียบร้อยแล้วและรายการถูกอัปเดต!");
      } else {
        setAlertMessage(`❌ ลบไฟล์ไม่สำเร็จ: ${data.message}`);
      }
    } catch (err) {
      console.error("❌ Failed to delete file:", err);
      setAlertMessage("❌ ไม่สามารถลบไฟล์ได้ กรุณาลองใหม่อีกครั้ง");
    } finally {
      setTimeout(() => setAlertMessage(""), 3000);
      setIsSubmitting(false);
    }
  };

  const displayFormattedText = (text) => {
    if (!text) return null;
    return text.split("\n").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split("\n").length - 1 && <br />}
      </React.Fragment>
    ));
  };

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [responses]);

  useEffect(() => {
    if (Array.isArray(ticket.attachedFiles)) {
      setAttachedFiles(ticket.attachedFiles);
    } else {
      setAttachedFiles([]);
    }
  }, [ticket.attachedFiles]);

useEffect(() => {
  const socketConnection = io(
    "",
    {
      withCredentials: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    },
  );

  setSocket(socketConnection);

  const handleConnect = () => {
  };

  const handleDisconnect = (reason) => {
  };

  const handlePageShow = (event) => {
    if (
      event.persisted &&
      !socketConnection.connected
    ) {
      socketConnection.connect();
    }
  };

  socketConnection.on(
    "connect",
    handleConnect,
  );

  socketConnection.on(
    "disconnect",
    handleDisconnect,
  );

  window.addEventListener(
    "pageshow",
    handlePageShow,
  );

  return () => {
    window.removeEventListener(
      "pageshow",
      handlePageShow,
    );

    socketConnection.off(
      "connect",
      handleConnect,
    );

    socketConnection.off(
      "disconnect",
      handleDisconnect,
    );

    socketConnection.disconnect();
  };
}, []);

  useEffect(() => {
    if (!socket) return;

    const handleNewMessage = (messageData) => {
      setResponses((prev) => {
        const exists = prev.some((msg) => msg.id === messageData.id);
        return exists ? prev : [...prev, messageData];
      });
    };

    socket.on("ticketResponse", handleNewMessage);

    return () => {
      socket.off("ticketResponse", handleNewMessage);
    };
  }, [socket]);

  useEffect(() => {
    if (socket && ticket?.id) {
      socket.emit("joinTicket", { ticketNumber: ticket.id });

      return () => {
        socket.emit("leaveTicket", { ticketNumber: ticket.id });
      };
    }
  }, [socket, ticket?.id]);

  useEffect(() => {
    setUserEmail(me?.email || "");
  }, [me]);

  useEffect(() => {
    if (!ticket?.id) return;

    const controller = new AbortController();

    (async () => {
      try {
        await axios.get("/authadmin/me", {
          withCredentials: true,
          signal: controller.signal,
        });

        const res = await axios.get(
          "/ticketadmin/messageadmin",
          {
            params: { ticketNumber: ticket.id },
            withCredentials: true,
            validateStatus: (s) => s >= 200 && s < 500,
            signal: controller.signal,
          },
        );

        if (res.status === 404) {
          setResponses([]);
        } else {
          const list = Array.isArray(res.data) ? res.data : [];
          setResponses(list);
        }
      } catch (err) {
        if (axios.isCancel?.(err) || err?.name === "CanceledError") return;

        const status = err?.response?.status;

        if (status === 401) {
          navigate("/admin");
        } else if (status === 403) {
          alert("คุณไม่มีสิทธิ์เข้าถึง ticket นี้");
          navigate("/tickets");
        } else {
          console.error("Error fetching responses:", err);
        }
      }
    })();

    return () => controller.abort();
  }, [ticket?.id, navigate]);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get("/ticketadmin", {
          withCredentials: true,
        });
        setTickets(res.data || []);
      } catch (e) {
        console.error("Fetch tickets failed:", e);
      }
    })();
  }, []);

  useEffect(() => {
    const fetchDepartmentsAndEmployees = async () => {
      try {
        const departmentsResponse = await axios.get(
          "/department",
          {
            withCredentials: true,
          },
        );
        const departments = departmentsResponse.data;

        const employeesResponse = await axios.get(
          "/employees",
          {
            withCredentials: true,
          },
        );
        const employees = employeesResponse.data;
        const combinedData = departments.map((dept) => ({
          id: dept.id,
          name: dept.name,
          email: dept.email || "",
          members: employees
            .filter(
              (emp) => emp.department_id === dept.id && emp.is_active === 1,
            )
            .map((emp) => ({
              name: emp.name,
              email: emp.email,
            })),
        }));

        setDepartmentData(combinedData);
      } catch (error) {
        console.error("Error fetching departments or employees:", error);
      }
    };

    fetchDepartmentsAndEmployees();
  }, []);

  useEffect(() => {
    const fetchLastUpdate = async () => {
      try {
        const res = await axios.get(
          `/ticketadmin/last-update`,
          {
            params: { ticketId: ticket.id },
            withCredentials: true,
            validateStatus: (s) => s >= 200 && s < 500,
          },
        );

        if (res.status === 404) {
          setLastUpdate(null);
        } else {
          setLastUpdate(res.data?.lastUpdate ?? null);
        }
      } catch (error) {
        console.error("Error fetching last update", error);
        setLastUpdate(null);
      }
    };

    if (ticket?.id) {
      fetchLastUpdate();
    }
  }, [ticket]);

  const uploadFileToServer = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const res = await axios.post(
      "/ticketadmin/upload",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return res.data.filename;
  };

  const handleAddFiles = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    const max = 100 * 1024 * 1024;
    const tooBig = files.find((f) => f.size > max);
    if (tooBig) {
      alert(`ไฟล์ "${tooBig.name}" เกิน 100MB`);
      e.target.value = "";
      return;
    }

    setReplyFiles((prev) => {
      const key = (f) => `${f.name}__${f.size}`;
      const existing = new Set(prev.map(key));
      const merged = [...prev];
      for (const f of files) {
        if (!existing.has(key(f))) merged.push(f);
      }
      return merged;
    });

    e.target.value = "";
  };

  const handleRemoveReplyFile = (idx) => {
    setReplyFiles((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleRepairCaseTypeChange = (e) => {
    setPendingRepairCaseTypeId(e.target.value);
  };

  const handleConfirmRepairCaseTypeChange = async () => {
    const nextRepairCaseTypeId = pendingRepairCaseTypeId;

    if (!nextRepairCaseTypeId) {
      setAlertMessage("กรุณาเลือก Repair Action ก่อน");
      setTimeout(() => setAlertMessage(""), 3000);
      return;
    }

    if (nextRepairCaseTypeId === selectedRepairCaseTypeId) {
      setAlertMessage("รายการนี้เป็น Repair Action ปัจจุบันอยู่แล้ว");
      setTimeout(() => setAlertMessage(""), 3000);
      return;
    }

    const selectedType = repairCaseTypes.find(
      (item) => String(item.id) === String(nextRepairCaseTypeId),
    );

    let newSerial = "";

    if (Number(nextRepairCaseTypeId) === 1) {
      newSerial = await openSerialPopup({
        title: "กรอก Serial ใหม่",
        message: "กรุณากรอก Serial ใหม่ก่อนเปลี่ยน Repair Action",
      });

      if (!newSerial) {
        setAlertMessage("ยกเลิกการเปลี่ยน Repair Action");
        setTimeout(() => setAlertMessage(""), 3000);
        return;
      }
    }

    const confirmUpdate = await openConfirmPopup({
      title: "ยืนยันการเปลี่ยน Repair Action",
      message: `ต้องการเปลี่ยน Repair Action เป็น "${selectedType?.name_th || selectedType?.code}" ใช่หรือไม่?`,
      confirmText: "ยืนยันเปลี่ยน",
      cancelText: "ยกเลิก",
      variant: "primary",
    });

    if (!confirmUpdate) {
      setPendingRepairCaseTypeId(selectedRepairCaseTypeId);
      return;
    }

    setIsUpdatingRepairCase(true);

    try {
      const { data } = await axios.post(
        "/ticketadmin/updateRepairCaseType",
        {
          TicketNumber: ticket.id,
          repair_case_type_id: Number(nextRepairCaseTypeId),
          new_serial: newSerial,
        },
        {
          withCredentials: true,
        },
      );

      if (!data.success) {
        setAlertMessage(data.message || "อัปเดต Repair Action ไม่สำเร็จ");
        setTimeout(() => setAlertMessage(""), 3000);
        return;
      }

      setSelectedRepairCaseTypeId(String(nextRepairCaseTypeId));
      setPendingRepairCaseTypeId(String(nextRepairCaseTypeId));

      ticket.repair_case_type_id = Number(nextRepairCaseTypeId);
      ticket.repair_case_type_name_th = selectedType?.name_th || "";

      if (Number(nextRepairCaseTypeId) === 1 && newSerial) {
        setCurrentAssetSerial(newSerial);
        ticket.customer_asset_serial = newSerial;
      }

      setAlertMessage("✅ อัปเดต Repair Action สำเร็จ");
      setTimeout(() => setAlertMessage(""), 3000);
    } catch (err) {
      console.error("Failed to update repair action:", err);
      setAlertMessage(
        err.response?.data?.message || "ไม่สามารถอัปเดต Repair Action ได้",
      );
      setTimeout(() => setAlertMessage(""), 3000);
    } finally {
      setIsUpdatingRepairCase(false);
    }
  };

  const handleOpenAsset = () => {
    if (!ticket?.customer_asset_id) return;
    navigate(`/admin/customer-assets/${ticket.customer_asset_id}`);
  };

  const currentRepairCaseType = repairCaseTypes.find(
    (item) => String(item.id) === String(selectedRepairCaseTypeId),
  );

  const currentRepairCaseDisplay = currentRepairCaseType
    ? `${currentRepairCaseType.code}  (${currentRepairCaseType.name_th})`
    : "ยังไม่ได้ระบุ";

  const handleSaveRepairResultNote = async () => {
    if (!repairResultNote.trim()) {
      setRepairResultNoteSuccess("กรุณาเลือกหรือกรอกผลการดำเนินการก่อนบันทึก");
      setTimeout(() => setRepairResultNoteSuccess(""), 3000);
      return;
    }

    const confirmSave = await openConfirmPopup({
      title: "ยืนยันการบันทึก",
      message: "ต้องการบันทึกผลการดำเนินการนี้ใช่หรือไม่?",
      confirmText: "ยืนยันบันทึก",
      cancelText: "ยกเลิก",
      variant: "primary",
    });

    if (!confirmSave) {
      setRepairResultNoteSuccess("ยกเลิกการบันทึก");
      setTimeout(() => setRepairResultNoteSuccess(""), 3000);
      return;
    }

    setIsUpdatingRepairResultNote(true);
    setRepairResultNoteSuccess("");

    try {
      const { data } = await axios.post(
        "/ticketadmin/updateRepairResultNote",
        {
          TicketNumber: ticket.id,
          repair_result_note: repairResultNote,
        },
        {
          withCredentials: true,
        },
      );

      if (!data.success) {
        alert(data.message || "บันทึกผลการดำเนินการไม่สำเร็จ");
        return;
      }

      ticket.repair_result_note = data.repair_result_note || repairResultNote;

      setRepairResultNote(data.repair_result_note || repairResultNote);

      setRepairResultNoteSuccess("บันทึกผลการดำเนินการสำเร็จ");
      setTimeout(() => setRepairResultNoteSuccess(""), 3000);
    } catch (err) {
      console.error("Failed to update repair result note:", err);
      alert(err.response?.data?.message || "ไม่สามารถบันทึกผลการดำเนินการได้");
    } finally {
      setIsUpdatingRepairResultNote(false);
    }
  };

  const repairResultNoteOptions = [
    "ซ่อมอุปกรณ์เดิมเรียบร้อยแล้ว และอุปกรณ์พร้อมใช้งานตามปกติ",
    "เปลี่ยนอุปกรณ์ใหม่เรียบร้อยแล้ว",
    "ใช้อุปกรณ์สำรองชั่วคราวเรียบร้อยแล้ว",
    "สลับคืนจากอุปกรณ์สำรองเรียบร้อยแล้ว",
    "ตรวจสอบและให้บริการเรียบร้อยแล้ว",
    "ไม่พบปัญหาเพิ่มเติม",
    "รอดำเนินการต่อ",
  ];

  const currentRepairResultNoteDisplay =
    repairResultNote && repairResultNote.trim()
      ? repairResultNote
      : "ยังไม่ได้ระบุผลการดำเนินการ";

  return (
    <>
      <div className="ticket-details-container">
        <button
          className="back-btn"
          onClick={() => navigate("/admin/tickets")}
          style={{ marginLeft: "15px" }}
        >
          Back
        </button>
        <div className="ticket-detail-inline">
          <p className="Ticketnum">Ticket #{ticket.id}</p>
          <h3>Report: {ticket.IssueSummary}</h3>
          <br />
          <div className="row">
            <p>
              <strong>Company:</strong> {ticket.CompanyName || "Not Specified"}
            </p>
            <p>
              <strong>Status:</strong> <StatusBadge status={ticket.Status} />
            </p>
          </div>
          <div className="row">
            <p>
              <strong>User:</strong> {ticket.FullName}
              {ticket.is_active === 0 && " (Disabled)"}
            </p>

            <p>
              <strong>Email:</strong> {ticket.Email}
            </p>
          </div>
          <div className="row">
            <p>
              <strong>Department:</strong> {ticket.Position || "Not Available"}
            </p>
            <p>
              <strong>Create Date :</strong> {formatDate(ticket.Date)}
            </p>
          </div>
          <div className="row">
            <p>
              <strong>Phone:</strong> {ticket.Phone}
            </p>
            <p>
              <strong>Address:</strong> {ticket.Address || "Not Available"}
            </p>
          </div>
          <div className="row">
            <p style={{ margin: 0 }}>
              <strong>Serial Number:</strong>{" "}
              {ticket?.customer_asset_id ? (
                <a
                  href={`/admin/customer-assets/${ticket.customer_asset_id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleOpenAsset();
                  }}
                  style={{
                    color: "#2563eb",
                    cursor: "pointer",
                    textDecoration: "underline",
                    fontWeight: 500,
                  }}
                >
                  {currentAssetSerial || "-"}
                </a>
              ) : (
                "-"
              )}
            </p>
          </div>
        </div>

        <div className="ticket-detail-inline">
          <div className="row">
            <p>
              <strong>Assigned To:</strong> {me?.email || "Not Assigned"}
            </p>
            <p>
              <strong>Help Topic:</strong> {ticket.HelpTopic}
            </p>
          </div>
          <div className="row">
            <p>
              <strong>SLA:</strong>
              {ticket.SLA || "Not Assigned"}
            </p>
            <p>
              <strong>Last Update:</strong>{" "}
              {lastUpdate ? formatDate(lastUpdate) : "ยังไม่มีการอัปเดต"}
            </p>
          </div>
          <br />
          <div
            style={{
              gap: "0.5rem",
            }}
          >
            <strong>Detail: </strong>
            {isEditingSubject ? (
              <>
                <textarea
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  className="form-input"
                  style={{
                    flex: 1,
                    width: "700px",
                    minHeight: "90px",
                    padding: "8px",
                    resize: "vertical",
                  }}
                />
                <button
                  className="btn btn-primary"
                  style={{
                    height: "32px",
                    padding: "0 12px",
                    marginLeft: "5px",
                    marginRight: "5px",
                    whiteSpace: "nowrap",
                    background: "green",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: isUpdatingSubject ? "not-allowed" : "pointer",
                    transition: "background-color 0.2s ease",
                  }}
                  disabled={isUpdatingSubject}
                  onMouseEnter={(e) => {
                    if (!isUpdatingSubject)
                      e.target.style.backgroundColor = "#28a745";
                  }}
                  onMouseLeave={(e) => {
                    if (!isUpdatingSubject)
                      e.target.style.backgroundColor = "green";
                  }}
                  onMouseDown={(e) => {
                    if (!isUpdatingSubject)
                      e.target.style.backgroundColor = "#1e7e34";
                  }}
                  onMouseUp={(e) => {
                    if (!isUpdatingSubject)
                      e.target.style.backgroundColor = "#28a745";
                  }}
                  onClick={async () => {
                    setIsUpdatingSubject(true);
                    try {
                      await axios.post(
                        "/ticketadmin/updateDetail",
                        {
                          TicketNumber: ticket.id,
                          Detail: subject,
                        },
                        {
                          withCredentials: true,
                        },
                      );
                      ticket.Details = subject;
                      setIsEditingSubject(false);
                    } catch (error) {
                      console.error("Failed to update subject", error);
                    } finally {
                      setIsUpdatingSubject(false);
                    }
                  }}
                >
                  {isUpdatingSubject ? "Saving..." : "Save"}
                </button>

                <button
                  className="btn"
                  style={{
                    height: "32px",
                    padding: "0 12px",
                    marginTop: "10px",
                    borderRadius: "5px",
                    border: "none",
                    color: "white",
                    cursor: "pointer",
                    backgroundColor: "gray",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#5a5a5a")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "gray")
                  }
                  onMouseDown={(e) =>
                    (e.target.style.backgroundColor = "#3a3a3a")
                  }
                  onMouseUp={(e) =>
                    (e.target.style.backgroundColor = "#5a5a5a")
                  }
                  onClick={() => {
                    setIsEditingSubject(false);
                    setSubject(ticket.Details);
                  }}
                >
                  Cancel
                </button>
              </>
            ) : (
              <>
                <span style={{ marginLeft: "10px" }}>{ticket.Details}</span>
                <button
                  className="btn btn-primary"
                  style={{
                    height: "32px",
                    padding: "4px 12px",
                    whiteSpace: "nowrap",
                    marginLeft: "10px",
                  }}
                  onClick={() => setIsEditingSubject(true)}
                >
                  Edit
                </button>
              </>
            )}
          </div>
          <br />

          <div
            className="row"
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "1rem",
            }}
          >
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <span style={{ fontWeight: "bold" }}>Priority (Current):</span>
              <PriorityIndicator level={ticket.SeverityLevels} />
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              marginTop: "10px",
              flexWrap: "wrap",
            }}
          >
            <span style={{ fontWeight: "bold" }}>Change Priority:</span>

            <select
              value={newSeverity}
              onChange={(e) => setNewSeverity(e.target.value)}
              className="form-select"
              style={{
                minWidth: "90px",
                height: "32px",
                padding: "4px 8px",
              }}
            >
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
            </select>

            <button
              className="btn btn-primary"
              style={{
                height: "32px",
                padding: "4px 12px",
                whiteSpace: "nowrap",
              }}
              onClick={async () => {
                setIsUpdatingSeverity(true);

                try {
                  await axios.post(
                    "/ticketadmin/updateSeverity",
                    {
                      TicketNumber: ticket.id,
                      SeverityLevels: newSeverity,
                    },
                    {
                      withCredentials: true,
                    },
                  );

                  ticket.SeverityLevels = newSeverity;
                  setAlertMessage("✅ อัปเดต Priority สำเร็จ");
                  setTimeout(() => setAlertMessage(""), 3000);
                } catch (error) {
                  console.error("Failed to update severity", error);
                  setAlertMessage("❌ ไม่สามารถอัปเดต Priority ได้");
                  setTimeout(() => setAlertMessage(""), 3000);
                } finally {
                  setIsUpdatingSeverity(false);
                }
              }}
              disabled={isUpdatingSeverity}
            >
              {isUpdatingSeverity ? "Updating..." : "Confirm"}
            </button>
          </div>

          <div className="repair-action-box">
            <div className="repair-action-current">
              <span className="repair-action-label">Repair Action:</span>
              <span className="repair-action-value">
                {currentRepairCaseDisplay}{" "}
              </span>
            </div>

            <div className="repair-action-change">
              <label className="repair-action-select-label">
                Change Repair Action:
              </label>

              <select
                value={pendingRepairCaseTypeId}
                onChange={handleRepairCaseTypeChange}
                className="repair-action-select"
                disabled={isUpdatingRepairCase}
              >
                <option value="">-- Select Repair Action --</option>

                {repairCaseTypes.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.code}
                    {String(item.id) === String(selectedRepairCaseTypeId)
                      ? " (รายการปัจจุบัน)"
                      : ""}
                  </option>
                ))}
              </select>

              <button
                type="button"
                className="repair-action-confirm-btn"
                onClick={handleConfirmRepairCaseTypeChange}
                disabled={
                  isUpdatingRepairCase ||
                  !pendingRepairCaseTypeId ||
                  pendingRepairCaseTypeId === selectedRepairCaseTypeId
                }
              >
                {isUpdatingRepairCase ? "Updating..." : "Confirm"}
              </button>

              {isUpdatingRepairCase && (
                <span className="repair-action-updating">Updating...</span>
              )}
            </div>
          </div>

          <div className="repair-result-note-box">
            <label className="repair-result-note-label">
              Repair Result Note
            </label>

            <div className="repair-result-current">
              <span className="repair-result-current-label">
                รายการปัจจุบัน:
              </span>

              <span className="repair-result-current-value">
                {currentRepairResultNoteDisplay}
              </span>
            </div>

            <select
              className="repair-result-note-select"
              value={
                isWritingCustomRepairResult ? "__CUSTOM__" : repairResultNote
              }
              onChange={(e) => {
                const value = e.target.value;

                if (value === "__CUSTOM__") {
                  setIsWritingCustomRepairResult(true);
                  setRepairResultNote("");
                  return;
                }

                setIsWritingCustomRepairResult(false);
                setRepairResultNote(value);
              }}
            >
              <option value="">-- เลือกผลการดำเนินการ --</option>

              {repairResultNoteOptions.map((item) => (
                <option key={item} value={item}>
                  {item}
                  {item === repairResultNote ? " (รายการปัจจุบัน)" : ""}
                </option>
              ))}

              <option value="__CUSTOM__">อื่น ๆ</option>
            </select>
            {isWritingCustomRepairResult && (
              <textarea
                className="repair-result-note-textarea"
                value={repairResultNote}
                onChange={(e) => setRepairResultNote(e.target.value)}
                placeholder="เขียนผลการดำเนินการเอง เช่น ซ่อมเรียบร้อยแล้ว ทดสอบการใช้งานผ่าน และส่งคืนลูกค้าเรียบร้อย"
                rows={3}
              />
            )}

            <button
              type="button"
              className="repair-result-note-button"
              onClick={handleSaveRepairResultNote}
              disabled={isUpdatingRepairResultNote}
            >
              {isUpdatingRepairResultNote ? "Saving..." : "Save Result Note"}
            </button>

            {repairResultNoteSuccess && (
              <div className="repair-result-note-success">
                {repairResultNoteSuccess}
              </div>
            )}
          </div>
          <br />
          <div>
            <p>
              <strong>Files:</strong>
            </p>
            <ul className="attachments-list">
              {attachedFiles && attachedFiles.length > 0 ? (
                attachedFiles.map((file, index) => (
                  <li key={index} className="attachments-item">
                    <a
                      className="attachments-link"
                      href={`/fileuploads/${encodeURIComponent(file)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginRight: 10 }}
                    >
                      {file}
                    </a>
                    <button
                      className="btn-delete-file"
                      onClick={() => handleDeleteFile(file)}
                    >
                      Delete
                    </button>
                  </li>
                ))
              ) : (
                <li className="attachments-item attachments-empty">
                  ไม่มีไฟล์แนบ
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="ticket-detail-inline">
          <h3>Conversation</h3>
          <div
            className="chat-messages"
            ref={chatContainerRef}
            style={{
              maxHeight: "400px",
              overflowY: "auto",
              border: "1px solid #ddd",
              padding: "15px",
              marginTop: "15px",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            {responses.map((response) => {
              const isAdmin =
                response.senderType === "admin" ||
                (response.employee_id !== null &&
                  response.employee_id !== undefined);

              return (
                <div
                  key={response.id}
                  style={{
                    display: "flex",
                    justifyContent: isAdmin ? "flex-end" : "flex-start",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: isAdmin ? "#e8f5e9" : "#f8f9fa",
                      borderRadius: "12px",
                      padding: "12px 16px",
                      maxWidth: "80%",
                      width: "80%",
                      minWidth: "80px",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      wordBreak: "break-word",
                    }}
                  >
                    <div
                      style={{
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {displayFormattedText(response.Message)}
                    </div>

                    {response.AttachFiles && (
                      <div style={{ marginTop: "8px" }}>
                        {Array.isArray(response.AttachFiles) ? (
                          <ul className="attachments-list">
                            {response.AttachFiles.map((file, index) => (
                              <li key={index} className="attachments-item">
                                <a
                                  className="attachments-link"
                                  href={`/fileuploads/${encodeURIComponent(
                                    file,
                                  )}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {file}
                                </a>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <a
                            href={`/fileuploads/${encodeURIComponent(
                              response.AttachFiles,
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {response.AttachFiles}
                          </a>
                        )}
                      </div>
                    )}

                    <div
                      style={{
                        fontSize: "12px",
                        color: "#777",
                        textAlign: isAdmin ? "right" : "left",
                        borderTop: "1px solid #ccc",
                        paddingTop: "4px",
                      }}
                    >
                      <div>
                        {isAdmin
                          ? `👨‍💼 Admin: ${response.senderName || "Admin"}`
                          : `🙋‍♂️ Customer: ${response.senderName || "Customer"}`}
                      </div>

                      <div>{formatDate(response.created_at)}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="ticket-detail-inline">
          <form onSubmit={handleSubmit}>
            <p className="Ticketnum">Ticket #{ticket.id}</p>
            <div className="row">
              <p>
                <strong>From:</strong> {userEmail}
              </p>
              <p>
                <strong>Recipients:</strong> {ticket.Email}
              </p>
            </div>
            <div className="flex">
              <label>
                <strong>Attach File:</strong>
              </label>
              <input
                ref={fileInputRef}
                type="file"
                multiple
                onChange={handleAddFiles}
                style={{
                  width: "50%",
                  padding: "6px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            {replyFiles.length > 0 && (
              <ul className="attachments-list">
                {replyFiles.map((f, i) => (
                  <li key={i} className="attachments-item">
                    <span style={{ marginRight: 8 }}>
                      📎 {f.name} ({Math.ceil(f.size / 1024)} KB)
                    </span>
                    <button
                      type="button"
                      className="btn-remove-file"
                      onClick={() => handleRemoveReplyFile(i)}
                    >
                      Remove
                    </button>
                  </li>
                ))}
              </ul>
            )}

            <div className="row">
              <div className="form-group">
                <label>
                  <strong>Reply To:</strong>
                </label>
                <DepartmentDropdown
                  departments={departmentData}
                  selectedItems={selectedRecipients || []}
                  onChange={setSelectedRecipients}
                  userEmail={ticket.Email}
                  customerId={ticket.customer_id}
                />
              </div>
            </div>

            <div className="row">
              <div className="form-group">
                <label>
                  <strong>Additional Recipients:</strong>
                </label>
                <textarea
                  value={recipients}
                  onChange={(e) => setRecipients(e.target.value)}
                  placeholder="Please enter your message here...."
                  className="form-input"
                  style={{
                    height: "150px",
                    padding: "10px",
                    whiteSpace: "pre-wrap",
                    maxWidth: "100%",
                    width: "100%",
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="form-group">
                <label>
                  <strong>Ticket Status:</strong>
                </label>
                <select
                  value={ticketStatus}
                  onChange={(e) => setTicketStatus(e.target.value)}
                  className="form-select"
                >
                  <option value="open">Open</option>
                  <option value="foundcause">Found cause</option>
                  <option value="nextfollowup">Next Followup</option>
                  <option value="closed">Closed</option>
                </select>
              </div>

              {ticketStatus === "nextfollowup" && (
                <div className="form-group" style={{ marginTop: "0.5rem" }}>
                  <label>
                    <strong>Follow‑up Date:</strong>
                  </label>
                  <input
                    type="date"
                    value={nextFollowupDate}
                    onChange={(e) => setNextFollowupDate(e.target.value)}
                    className="form-input"
                    style={{ width: "200px", padding: "4px 8px" }}
                    min={today}
                  />
                </div>
              )}
            </div>
            {alertMessage && <div className="alert">{alertMessage}</div>}
            <br />
            <div className="row">
              <button
                type="submit"
                className="btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Reply"}
              </button>
            </div>
          </form>
        </div>
        {confirmPopup.open && (
          <div className="td-confirm-overlay">
            <div className="td-confirm-modal">
              <h3>{confirmPopup.title}</h3>

              <p>{confirmPopup.message}</p>

              <div className="td-confirm-actions">
                <button
                  type="button"
                  className={`td-confirm-ok-btn ${
                    confirmPopup.variant === "danger" ? "danger" : ""
                  }`}
                  onClick={() => closeConfirmPopup(true)}
                >
                  {confirmPopup.confirmText}
                </button>

                <button
                  type="button"
                  className="td-confirm-cancel-btn"
                  onClick={() => closeConfirmPopup(false)}
                >
                  {confirmPopup.cancelText}
                </button>
              </div>
            </div>
          </div>
        )}
        {serialPopup.open && (
          <div className="td-confirm-overlay">
            <div className="td-confirm-modal">
              <h3>{serialPopup.title}</h3>

              <p>{serialPopup.message}</p>

              <div className="td-serial-field">
                <label>Serial ใหม่</label>
                <input
                  type="text"
                  value={serialPopup.value}
                  onChange={(e) =>
                    setSerialPopup((prev) => ({
                      ...prev,
                      value: e.target.value,
                      error: "",
                    }))
                  }
                  placeholder="กรอก Serial ใหม่"
                  autoFocus
                />

                {serialPopup.error && (
                  <div className="td-serial-error">{serialPopup.error}</div>
                )}
              </div>

              <div className="td-confirm-actions">
                <button
                  type="button"
                  className="td-confirm-ok-btn"
                  onClick={confirmSerialPopup}
                >
                  ยืนยัน
                </button>

                <button
                  type="button"
                  className="td-confirm-cancel-btn"
                  onClick={() => closeSerialPopup("")}
                >
                  ยกเลิก
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TicketDetailAdmin2;
